module.exports = require("./lib/_stream_duplex.js")



/*****************
 ** WEBPACK FOOTER
 ** (webpack)/~/stream-browserify/~/readable-stream/duplex.js
 ** module id = 4199
 ** module chunks = 0
 **/